module.exports = __webpack_public_path__ + "static/img/6.593316d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/cooperation/6.png
// module id = KdXo
// module chunks = 3